import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Login from './pages/Login';
import LeagueDetail from './pages/LeagueDetail';
import Register from './pages/Register';
import CreateProposal from './pages/CreateProposal';
import Profile from './pages/Profile';
import MyMatches from './pages/MyMatches';
import LeagueMembers from './pages/LeagueMembers';
import LeaguePlayerLinks from './pages/LeaguePlayerLinks';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './App.css';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const location = useLocation();

  if (!token) {
    localStorage.setItem('redirectAfterLogin', location.pathname);
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || "733481284501-8bofvckm816j2p1sh0e9o3q9re4618e6.apps.googleusercontent.com";

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <BrowserRouter>
        <Navbar />
        <div className="container">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={<Home />} />
            
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/my-matches" element={<ProtectedRoute><MyMatches /></ProtectedRoute>} />
            <Route path="/league/:leagueId" element={<ProtectedRoute><LeagueDetail /></ProtectedRoute>} />
            <Route path="/league/:leagueId/members" element={<ProtectedRoute><LeagueMembers /></ProtectedRoute>} />
            <Route path="/league/:leagueId/player-links" element={<ProtectedRoute><LeaguePlayerLinks /></ProtectedRoute>} />
            <Route path="/league/:leagueId/create-proposal" element={<ProtectedRoute><CreateProposal /></ProtectedRoute>} />
          </Routes>
        </div>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
}

export default App;
